import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Col, Row, StaticField } from "@intech/web-ui";
import { FichaContribPrevidencialService } from "@services";
import { PlanoVinculadoEntidade, SaldoAcumuladoEntidade, SaldoEntidade } from "@entidades";
import { LoadingComponent } from "@components";
import { FaMoneyCheck } from "react-icons/fa";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Quotas } from "../Quotas";

interface IProps {
  plano: PlanoVinculadoEntidade;
}

export const SaldoAcumulado: React.FC<IProps> = ({ plano }) => {
  const history = useHistory();

  const [Saldos, setSaldos] = useState<SaldoAcumuladoEntidade>(null);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const saldos = await FichaContribPrevidencialService.BuscarSaldos(plano.SQ_PLANO_PREVIDENCIAL);
        setSaldos(saldos);
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [plano]);

  const AbrirExtrato = useCallback(() => {
    history.push("extrato");
  }, [history]);

  return (
    <Box title={<b>{"Saldo Acumulado"}</b>}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && !Saldos && <Alert type={"info"}>{"Nehuma informação disponível no momento."}</Alert>}

      {!Loading && !Erro && Saldos &&
        <>
          {Saldos.Lista.length > 0 && <>
            {Saldos.Lista.length > 2 &&
              <h3 className={"text-center text-primary mb-5"}>
                {"Parabéns! Você já acumulou "}<b className={"text-secondary"}><StaticField value={Saldos.Lista[2].VL_ATUALIZADO} type={"money"} /></b>
              </h3>
            }

            {Saldos.Lista.length <= 2 &&
              <h3 className={"text-center text-primary mb-5"}>
                {"Parabéns! Você já acumulou "}<b className={"text-secondary"}><StaticField value={Saldos.Lista[Saldos.Lista.length - 1].VL_ATUALIZADO} type={"money"} /></b>
              </h3>
            }
          </>}

          <Row>
            <Col>
              {Saldos.Lista.length > 0 && <>
                <table className={"table table-striped table-sm"}>
                  <thead>
                    <tr>
                      <th>{"Fundo"}</th>
                      <th className={"text-right"}>{"Saldo Atualizado"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Saldos.Lista.map((saldo: SaldoEntidade, index: number) => {
                      // Define o tipo de linha (td ou th) baseado no index. Se for o ultimo, será o total, e será th
                      var Td = (props: any) => <td className={props.className}>{props.children}</td>;

                      if (index === Saldos.Lista.length - 1)
                        Td = (props: any) => <th className={props.className}>{props.children}</th>;

                      return (
                        <tr key={index}>
                          <Td>{saldo.DS_TIPO_FUNDO}</Td>
                          <Td className={"text-right"}>
                            <StaticField value={saldo.VL_ATUALIZADO} type={"money"} />
                          </Td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </>}
            </Col>

            <Col>
              <Quotas plano={plano} />
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                onClick={AbrirExtrato}
                title={"Ir Para o Extrato"}
                type={"primary"}
                icon={<FaMoneyCheck />}
              />
            </Col>
          </Row>
        </>}
    </Box>
  );
}